import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3923ee82"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-1-left" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ABOUT US", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-1-right" }, null, -1))
const _hoisted_4 = {
  key: 2,
  class: "style-3"
}
const _hoisted_5 = {
  key: 3,
  class: "style-4"
}
const _hoisted_6 = { class: "style-4-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-4-title-bg" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "style-4-title-bg2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-4-tip" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "style-4-tip-t" }, [
    /*#__PURE__*/_createTextVNode("公司简介 "),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "notice" }

import {editor} from "@/app/editor";
import {IntroductionSectionV1} from "@/app/editor/modules/introduction/v1/index";
import FrameContentPreview from "@/app/editor/views/FrameContentPreview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroductionPreview',
  props: {
    index: {}
  },
  setup(__props: any) {

const props = __props
const introduction = editor.activity?.modules[props.index] as IntroductionSectionV1

return (_ctx: any,_cache: any) => {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_typography = _resolveComponent("a-typography")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`section_${_ctx.index}`)
    }, null, 2),
    _createVNode(FrameContentPreview, {
      class: "images",
      title: "风采展示"
    }, {
      default: _withCtx(() => [
        (_unref(introduction).config.shop_style == 0)
          ? (_openBlock(), _createBlock(_component_a_flex, {
              key: 0,
              class: "style-1"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_a_flex, {
                  vertical: "",
                  class: "style-1-title",
                  align: "flex-start"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_a_typography_text, { ellipsis: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(editor).activity.status.shop_name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              _: 1
            }))
          : (_unref(introduction).config.shop_style == 1)
            ? (_openBlock(), _createBlock(_component_a_typography_text, {
                key: 1,
                class: "style-2",
                ellipsis: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(editor).activity.status.shop_name), 1)
                ]),
                _: 1
              }))
            : (_unref(introduction).config.shop_style == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(_unref(editor).activity.status.shop_name), 1)
                ]))
              : (_unref(introduction).config.shop_style == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString(_unref(editor).activity.status.shop_name), 1),
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true),
        _createVNode(_component_a_typography, { style: {"text-align":"left","padding-bottom":"12px"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(introduction).config.shop_content.split('\n'), (c, k) => {
              return (_openBlock(), _createBlock(_component_a_typography, { key: k }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(c), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(introduction).config.content_images, (i) => {
          return (_openBlock(), _createElementBlock("img", {
            key: i,
            src: i.includes('dummyimage.com') ? i : i+'-720p',
            alt: ""
          }, null, 8, _hoisted_10))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(FrameContentPreview, { title: "活动须知" }, {
      default: _withCtx(() => [
        _createElementVNode("ol", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).activity?.status.rules, (gr, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gr, (r) => {
                return (_openBlock(), _createElementBlock("li", { key: r }, _toDisplayString(r), 1))
              }), 128))
            ], 64))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(introduction).config.notice, (s, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(s), 1))
          }), 128))
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})